var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { useFocusVisible } from '../../hooks/useFocusVisible';
export const Tab = (_a) => {
    var { action, active, className, disabled, onFocus, onBlur } = _a, props = __rest(_a, ["action", "active", "className", "disabled", "onFocus", "onBlur"]);
    let TabElement = 'button';
    const itemRef = React.useRef(null);
    const { isFocusVisible, focusFunction, blurFunction } = useFocusVisible(itemRef, onBlur, onFocus);
    if (props.href)
        TabElement = 'a';
    const TabClasses = classnames('Tab', className, {
        'Tab--active': active,
        'Tab--inactive': !active,
        'Tab--disabled': disabled,
        'Tab--focus-visible': isFocusVisible,
    });
    return (React.createElement(TabElement, Object.assign({ role: "tab", disabled: !props.href ? disabled : null, "aria-disabled": props.href ? disabled : null, "aria-selected": active, ref: itemRef, tabIndex: props.tabIndex || disabled ? -1 : 0, className: TabClasses, onFocus: focusFunction, onBlur: blurFunction, "data-anvil-component": "Tab" }, props)));
};
//# sourceMappingURL=Tab.js.map